import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimeRemainingCountdownComponent } from './time-remaining-countdown.component';
import { TimeUtilsService } from 'go-modules/time/time.service';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule
	],
	exports: [TimeRemainingCountdownComponent],
	declarations: [TimeRemainingCountdownComponent],
	providers: [TimeUtilsService]
})

export class TimeRemainingCountdownModule {}
